/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pxk_Sp_Scan_Not_In_NoteInputs */

const vi_pxk_sp_scan_not_in_note = /** @type {(inputs: Pxk_Sp_Scan_Not_In_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô không thuộc phiếu này`)
};

/**

* @param {Pxk_Sp_Scan_Not_In_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxk_sp_scan_not_in_note = /** @type {((inputs?: Pxk_Sp_Scan_Not_In_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxk_Sp_Scan_Not_In_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxk_sp_scan_not_in_note(inputs)
});